import { useQuery } from "react-query";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import PageHeader from "../../Components/PageHeader";
import { getProfile } from "../../Services/Profile";
import { useEffect } from "react";
import { setUser } from "../../Redux/slice";

export default function Profile() {
    const dispatch = useDispatch();
    const { data } = useQuery("getProfile", getProfile);

    useEffect(() => {
        if (data?.data?.user) {
            dispatch(setUser(data?.data?.user));
        }
    }, [data?.data?.user, dispatch]);

    const user = data?.data?.user;

    return (
        <div className="app-content content dashboard">
            <div className="content-wrapper">
                <div className="content-body">
                    <section id="configuration">
                        <div className="user-details-wrapper">
                            <PageHeader
                                title="Profile"
                                subtitle="View and update your admin account information"
                            />
                            <div className="row">
                                <div className="col-lg-10 col-xl-8">
                                    <div className="details-card-premium p-4 p-lg-5 text-center">
                                        <div className="userIimageFrame mx-auto mb-3 shadow-sm" style={{ width: '120px', height: '120px', borderRadius: '50%', overflow: 'hidden', border: '4px solid #fff' }}>
                                            <img
                                                src={user?.profileImage?.imageUrl ?? "images/avatar.png"}
                                                alt=""
                                                className="img-fluid w-100 h-100 object-fit-cover"
                                            />
                                        </div>
                                        <Link to="/profile/edit" className="accentColor text-decoration-underline fw-bold mb-5 d-inline-block">
                                            Edit Profile
                                        </Link>

                                        <div className="text-start mt-4">
                                            <div className="mainDetail">
                                                <label className="mainLabel">Name</label>
                                                <p className="mainText">{user?.firstName || "-"}</p>
                                            </div>
                                            <div className="mainDetail">
                                                <label className="mainLabel">Email Address</label>
                                                <p className="mainText">{user?.email || "-"}</p>
                                            </div>
                                        </div>

                                        <div className="mt-5 pt-3">
                                            <Link to="/profile/change-password" data-ignore-back className="siteBtn px-5 w-auto">
                                                Change Password
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}
